import { Route, Routes } from "react-router-dom";
import Home from "./pages/home.jsx";
import Footer from "./components/footer.jsx";

import SwapGold from "./pages/swapGold.jsx";
import { NavbarProvider } from "./providers/navbar.js";
import Header from "./components/header.jsx";
import Navbar from "./components/navbar.jsx";
import Stake from "./pages/stake.jsx";
import StakePosition from "./pages/stakePosition.jsx";
import Blog from "./pages/blog.jsx";
import Contact from "./pages/contact.jsx";
import NotFound from "./pages/notFound.jsx";

const App = () => {
  return (
    <NavbarProvider>
      <div className="flex flex-col justify-between bg-black/70 ellipse-background ">
        <Header />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/swapgold" element={<SwapGold />} />
          <Route path="/stake" element={<Stake />} />
          <Route path="/stakeposition" element={<StakePosition />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </NavbarProvider>
  );
};

export default App;
